import React from 'react';

const Superlister = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 2 14 13"
    width="11"
    height="10"
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M14.957 5.976l-2.228-3.818A.319.319 0 0 0 12.455 2h-8.91a.318.318 0 0 0-.274.158L1.043 5.976a.318.318 0 0 0 .045.38l6.682 7a.317.317 0 0 0 .46 0l6.682-7a.318.318 0 0 0 .045-.38z"
    />
  </svg>
);

export default Superlister;
